import React from 'react';
import CustomCloseButton from './Wrapper';

const MenuButton = ({ ...rest }) => (
  <CustomCloseButton {...rest}></CustomCloseButton>
);

MenuButton.propTypes = {};
export default MenuButton;
